import React from 'react'
import PropTypes from 'prop-types'
import { BaseEdge, getBezierPath, useStore } from '@xyflow/react'

const zoomSelector = (s) => s.transform[2] >= 0.9

export default function ZoomAwareEdge ({ id, sourceX, sourceY, targetX, targetY, data }) {
  const [edgePath] = getBezierPath({ sourceX, sourceY, targetX, targetY })
  const showContent = useStore(zoomSelector)

  if (!showContent) {
    return null
  }

  return (
    <>
      <BaseEdge path={edgePath} id={id} />
    </>
  )
}

ZoomAwareEdge.propTypes = {
  id: PropTypes.string.isRequired,
  sourceX: PropTypes.number.isRequired,
  sourceY: PropTypes.number.isRequired,
  targetX: PropTypes.number.isRequired,
  targetY: PropTypes.number.isRequired,
  data: PropTypes.shape({
    relationship: PropTypes.string
  })
}
